<template>
  <div class="color-legend-wrapper">
    <p class="color-legend-title">Potential Vulnerability</p>
  <div class="color-legend" :class="orientation">
    <div class="color-label left-label">Low</div>
    <div class="color-row">
      <div class="legend-color-block one">
        <span class="sr-only">1</span>
      </div>
    </div>
    <div class="color-row">
      <div class="legend-color-block two">
        <span class="sr-only">2</span>
      </div>
    </div>
    <div class="color-row">
      <div class="legend-color-block three">
        <span class="sr-only">3</span>
      </div>
    </div>
    <div class="color-row">
      <div class="legend-color-block four">
        <span class="sr-only">4</span>
      </div>
    </div>
    <div class="color-row">
      <div class="legend-color-block five">
        <span class="sr-only">5</span>
      </div>
    </div>
    <div class="color-row">
      <div class="legend-color-block six">
        <span class="sr-only">6</span>
      </div>
    </div>
    <div class="color-label right-label">High</div>
  </div>
  </div>
</template>

<script>
export default {
  name: 'color-legend',
  props: ['orientation'],
};
</script>

<style lang="less">
  .color-label {
    &.left-label {
      margin-right: 4px;
    }
    &.right-label {
      margin-left: 4px;
    }
  }
  .color-legend {
    display: flex;
    justify-content: center;

    &.column {
      flex-direction: column;
      .legend-color-block {
        margin-left: auto;
        margin-right: auto;
      }
    }
    &.horizontal {
      flex-direction: row;
      margin-left: 5px;
      margin-right: 5px;
      align-items: flex-end;
      .color-row {
        padding: 0 2px;
      } 
    }
  }
  .color-legend-title {
    margin: 0;
    text-align: center;
  }
  .color-legend-wrapper {
    align-self: flex-end;
    @media (max-width: 500px) {
      align-self: center;
    }
  }
  .color-row {
    margin-top: 2px;
    margin-bottom: 2px;
  }
  .legend-color-block {
    height: 20px;
    width: 30px;
    @media (max-width: 800px) and (min-width:500px) {
      width: 20px;
    };
  }
</style>



// WEBPACK FOOTER //
// ColorLegend.vue?43d5f81a